import { UserItem } from './users.types';
import { SettingsController } from './settings.controller';
import { SectorPermission } from './settings.types';
import api from '../../utils/api';

const STORAGE_KEY = 'mc_users_config';

const INITIAL_USERS: UserItem[] = [
  {
    id: '23',
    fullName: 'Paulo Sérgio Marçal',
    sector: 'Administração',
    email: 'paulo.sergio@mastercoifa.com.br',
    username: 'paulo.sergio',
    cpf: '123.456.789-00',
    permissions: SettingsController.getFullPermissions(),
    status: 'ATIVO'
  }
];

export class UsersController {
  static list(): UserItem[] {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (!data) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_USERS));
        return INITIAL_USERS;
      }
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed)) {
        return parsed.map((u: any) => ({
          ...u,
          status: u.status || 'ATIVO'
        }));
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_USERS));
      return INITIAL_USERS;
    } catch {
      return INITIAL_USERS;
    }
  }

  static save(
    id: string | null,
    fullName: string,
    sector: string,
    email: string,
    username: string,
    cpf: string,
    permissions: SectorPermission,
    status: 'ATIVO' | 'INATIVO' = 'ATIVO'
  ): UserItem[] {
    const list = this.list();
    if (id) {
      // Edit mode
      const idx = list.findIndex(u => u.id === id);
      if (idx !== -1) {
        list[idx] = {
          id,
          fullName,
          sector,
          email,
          username,
          cpf,
          permissions,
          status,
        };
      }
    } else {
      // Generation of new ID
      const nextId = String(Math.max(...list.map(u => parseInt(u.id) || 0), 0) + 1).padStart(2, '0');
      list.push({
        id: nextId,
        fullName,
        sector,
        email,
        username,
        cpf,
        permissions,
        status,
      });
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    return list;
  }

  static delete(id: string): UserItem[] {
    let list = this.list();
    list = list.filter(u => u.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    return list;
  }

  static async listFromServer(): Promise<UserItem[]> {
    try {
      const response = await api.get<any[]>('/users');
      if (response.data && Array.isArray(response.data)) {
        const mapped = response.data.map((u: any) => ({
          id: String(u.id),
          fullName: u.fullName || u.full_name || '',
          sector: u.sector || u.role || 'Geral',
          email: u.email || '',
          username: u.username || '',
          cpf: u.cpf || '',
          permissions: u.permissions || SettingsController.getFullPermissions(),
          status: u.status || 'ATIVO'
        }));
        localStorage.setItem(STORAGE_KEY, JSON.stringify(mapped));
        return mapped;
      }
    } catch (err) {
      console.error('Erro ao buscar usuários do servidor:', err);
    }
    return this.list();
  }

  static async saveToServer(
    id: string | null,
    fullName: string,
    sector: string,
    email: string,
    username: string,
    cpf: string,
    permissions: SectorPermission,
    status: 'ATIVO' | 'INATIVO' = 'ATIVO'
  ): Promise<UserItem[]> {
    try {
      await api.post('/users', {
        id,
        full_name: fullName,
        role: sector,
        email,
        username,
        cpf,
        permissions,
        status
      });
      return await this.listFromServer();
    } catch (err) {
      console.error('Erro ao salvar usuário no servidor:', err);
      // Fallback local em caso de falha de conexão
      return this.save(id, fullName, sector, email, username, cpf, permissions, status);
    }
  }

  static async deleteFromServer(id: string): Promise<UserItem[]> {
    try {
      await api.post('/users/delete', { id });
      return await this.listFromServer();
    } catch (err) {
      console.error('Erro ao deletar usuário no servidor:', err);
      return this.delete(id);
    }
  }
}
